new GuidedTopics.EquationSolverPage({
  pageId: 'multi-step-equations',
  title: 'Multi-Step Equations',
  guideUrl: 'multi-step-equations-guide.html',
  showNumberLine: false,
  simplifyInstructions:
    '<p>Simplify the equation. You can distribute, combine like terms, or drag terms across the equals sign. Press <strong>Done</strong> when finished.</p>',
  presets: {
    'preset-distribute': {
      id: 'preset-distribute',
      name: 'With Parentheses',
      expressions: [],
      equations: ['2(n + 3) + 4 = 16'],
    },
    'preset-both-sides': {
      id: 'preset-both-sides',
      name: 'Variables on Both Sides',
      expressions: [],
      equations: ['5y - 3 = 2y + 12'],
    },
    'preset-multi': {
      id: 'preset-multi',
      name: 'Combine Like Terms',
      expressions: [],
      equations: ['4x - 7 + 2x = 17'],
    },
    'preset-complex': {
      id: 'preset-complex',
      name: 'Distribute & Collect',
      expressions: [],
      equations: ['3(a + 2) = a + 14'],
    },
    'preset-negative': {
      id: 'preset-negative',
      name: 'With Negatives',
      expressions: [],
      equations: ['-2x + 9 = 3'],
    },
  },
  headerPresets: [],
  wizard: {
    title: 'Create Multi-Step Equation',
    subtitle: 'Choose the equation form:',
    typeCards: {
      'multi-step': {
        name: 'Combine Like Terms',
        icon: 'ax + b + cx',
        examples: ['4x \u2212 7 + 2x = 17'],
      },
      'both-sides': {
        name: 'Variables on Both Sides',
        icon: 'ax + b = cx + d',
        examples: ['5y \u2212 3 = 2y + 12'],
      },
      distribute: {
        name: 'With Distribution',
        icon: 'a(x + b) = c',
        examples: ['2(n + 3) + 4 = 16'],
      },
    },
    typeOrder: ['multi-step', 'both-sides', 'distribute'],
    entryTemplates: {
      'multi-step': {
        expression: '\\numberbox x + \\numberbox + \\numberbox x = \\numberbox',
        slots: [
          {
            id: 'coeff1',
            label: 'first coefficient',
            type: 'integer',
            allowNegative: true,
            exclude: [0],
          },
          { id: 'constant', label: 'constant', type: 'integer', allowNegative: true },
          {
            id: 'coeff2',
            label: 'second coefficient',
            type: 'integer',
            allowNegative: true,
            exclude: [0],
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
      'both-sides': {
        expression: '\\numberbox x + \\numberbox = \\numberbox x + \\numberbox',
        slots: [
          {
            id: 'leftCoeff',
            label: 'left coefficient',
            type: 'integer',
            allowNegative: true,
            exclude: [0],
          },
          {
            id: 'leftConst',
            label: 'left constant',
            type: 'integer',
            allowNegative: true,
          },
          {
            id: 'rightCoeff',
            label: 'right coefficient',
            type: 'integer',
            allowNegative: true,
            exclude: [0],
          },
          {
            id: 'rightConst',
            label: 'right constant',
            type: 'integer',
            allowNegative: true,
          },
        ],
      },
      distribute: {
        expression: '\\numberbox (x + \\numberbox) = \\numberbox',
        slots: [
          {
            id: 'factor',
            label: 'factor',
            type: 'integer',
            allowNegative: true,
            exclude: [0, 1],
          },
          {
            id: 'inside',
            label: 'constant inside',
            type: 'integer',
            allowNegative: true,
          },
          { id: 'result', label: 'result', type: 'integer', allowNegative: true },
        ],
      },
    },
    buildEquation: (type, values) => {
      // Helper: format "+ N" or "- N" depending on sign
      const signedTerm = (val) => (val < 0 ? `- ${Math.abs(val)}` : `+ ${val}`);
      switch (type) {
        case 'multi-step':
          return `${values.coeff1}x ${signedTerm(values.constant)} ${signedTerm(values.coeff2)}x = ${values.result}`;
        case 'both-sides':
          return `${values.leftCoeff}x ${signedTerm(values.leftConst)} = ${values.rightCoeff}x ${signedTerm(values.rightConst)}`;
        case 'distribute':
          return `${values.factor}(x ${signedTerm(values.inside)}) = ${values.result}`;
        default:
          return 'x = 0';
      }
    },
  },
}).init();
